type Props = {
  className?: string;
};

export const AdHocUsage = (props: Props) => {
  return (
    <svg
      {...props}
      width="40"
      height="36"
      viewBox="0 0 40 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.3169 30.3139C16.0512 30.4277 15.751 30.4303 15.4834 30.3213L1.04186 24.4392C0.152546 24.077 0.141404 22.8217 1.02415 22.4438L23.6832 12.7423C23.9488 12.6285 24.249 12.6259 24.5166 12.7349L38.9582 18.617C39.8475 18.9792 39.8586 20.2345 38.9759 20.6124L16.3169 30.3139Z"
        fill="black"
        fillOpacity="0.06"
      />
      <path
        d="M36.5813 17.2688C36.927 17.4096 37.093 17.8039 36.9523 18.1496C36.8115 18.4953 36.4171 18.6614 36.0714 18.5206L32.0984 16.9024L30.1119 16.0932L32.6083 15.6506L36.5813 17.2688Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7051 9.05083L32.7051 16.62L31.3535 16.62L31.3535 9.05083L32.7051 9.05083Z"
        fill="black"
      />
      <path
        d="M16.9341 22.8125C16.2733 23.0909 15.529 23.0954 14.8649 22.8249L2.27044 17.6951C0.93229 17.1501 0.920969 15.2593 2.2525 14.6983L23.6072 5.70083C24.268 5.42241 25.0124 5.41795 25.6765 5.68844L38.2709 10.8182C39.6091 11.3632 39.6204 13.254 38.2889 13.8151L16.9341 22.8125Z"
        fill="#DCA3AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.77974 16.4434L15.3742 21.5731C15.7062 21.7084 16.0784 21.7061 16.4088 21.5669L37.7635 12.5695C37.8365 12.5387 37.8696 12.5019 37.889 12.4709C37.9123 12.4335 37.9292 12.3807 37.9289 12.3188C37.9285 12.2568 37.9109 12.2042 37.8872 12.1671C37.8674 12.1363 37.8339 12.0999 37.7605 12.07L25.1661 6.94025C24.834 6.80501 24.4619 6.80724 24.1315 6.94645L2.77675 15.9439C2.70374 15.9747 2.67066 16.0115 2.65129 16.0425C2.62795 16.0799 2.61102 16.1327 2.61139 16.1946C2.61176 16.2566 2.62933 16.3092 2.65311 16.3463C2.67284 16.377 2.70637 16.4135 2.77974 16.4434ZM14.8643 22.8249C15.5284 23.0954 16.2728 23.0909 16.9336 22.8125L38.2883 13.8151C39.6198 13.2541 39.6085 11.3633 38.2704 10.8182L25.6759 5.68847C25.0118 5.41798 24.2675 5.42243 23.6067 5.70086L2.25195 14.6983C0.920426 15.2593 0.931746 17.1501 2.2699 17.6952L7.56479 19.8518L7.56479 25.4129L4.84658 24.3057C4.50091 24.1649 4.10656 24.331 3.96577 24.6767C3.82498 25.0224 3.99106 25.4167 4.33673 25.5575L7.56479 26.8723V26.8933H7.61629L12.2828 28.794C12.6284 28.9348 13.0228 28.7687 13.1636 28.423C13.3044 28.0773 13.1383 27.683 12.7926 27.5422L8.91641 25.9634L8.91641 20.4023L14.8643 22.8249Z"
        fill="black"
      />
    </svg>
  );
};
